const PagerTokenCard = ({ tokens }) => (
    <div className='pagerTokenBox'>
        <div className='pagerTokenCard'><img src={tokens.image.startsWith('data:') ? tokens.image : `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(tokens.image)))}`} alt={`${tokens.name}`} /></div>
        <div className='MainTokenInfo'>
            <p className='TokenName'>{tokens.name}</p>
        </div>
    </div>
)
export default PagerTokenCard;
